import { appStore, IEvent, MessageBus } from '@tom-ui/utils'
import { CarrierType, CarrierVisitResponse, CarrierVisitStatus } from '@yard/app/api'
import { EventTypes } from '@yard/messages/eventsTypes'
import { DeleteResponse } from '@yard/messages/models/delete-response.model'
import { carrierVisitService } from '@yard/services/carrier-visit.service'
import { BaseEntityStore } from './base/BaseEntityStore'

export class CarrierVisitStore extends BaseEntityStore<CarrierVisitResponse> {
  private isFetched = false
  private readonly disposers: Array<() => void> = []

  constructor(private readonly messageBus: MessageBus) {
    super()

    this.disposers.push(
      this.messageBus.subscribeEvent<CarrierVisitResponse>(
        EventTypes.CarrierVisitUpsertedEvent,
        this.handleUpsertedEvent,
      ),
      this.messageBus.subscribeEvent<DeleteResponse>(
        EventTypes.CarrierVisitDeletedEvent,
        this.handleDeletedEvent,
      ),
    )
  }

  dispose(): void {
    this.disposers.forEach(d => d())
    this.disposers.length = 0
  }

  async loadCarrierVisits(
    ids?: number[],
    carrierType?: CarrierType,
    status?: CarrierVisitStatus,
    startDate?: string,
    endDate?: string,
  ) {
    if (this.isFetched) return
    try {
      const carrierVisits = await carrierVisitService.getCarrierVisits(
        ids,
        carrierType,
        status,
        startDate,
        endDate,
      )
      this.updateStoreItems(carrierVisits)
      this.isFetched = true
    } catch (e) {
      appStore.setShowAlert('error', (e as any)?.response?.data?.detail ?? 'An error occurred')
    }
  }

  private handleUpsertedEvent = (event: IEvent<CarrierVisitResponse>) => {
    const response = event.payload
    if (!response) return

    this.updateStoreItem(response, response.id)
  }

  private handleDeletedEvent = (event: IEvent<DeleteResponse>) => {
    const response = event.payload
    if (!response) return
    this.deleteStoreItem(response.id)
  }
}
